
(function() {
  var result = { translations: { "ko": { "i18n": { "duration": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84", "days": "{{ days }}\uC77C", "shortForm": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "days": "{{ days }}\uC77C", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} {{quarterNumber}}\uBD84\uAE30" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \uB0B4\uC120\uBC88\uD638: {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ko": "static-7.1127"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1127",
    "ar-eg": "static-7.1127",
    "bg": "static-7.1127",
    "bn": "static-7.1127",
    "ca-es": "static-7.1127",
    "cs": "static-7.1127",
    "da": "static-7.1127",
    "de": "static-7.1127",
    "el": "static-7.1127",
    "en-gb": "static-7.1127",
    "en": "static-7.1127",
    "es-mx": "static-7.1127",
    "es": "static-7.1127",
    "et": "static-7.1127",
    "fi": "static-7.1127",
    "fr-ca": "static-7.1127",
    "fr": "static-7.1127",
    "he-il": "static-7.1127",
    "hi": "static-7.1127",
    "hr": "static-7.1127",
    "hu": "static-7.1127",
    "id": "static-7.1127",
    "it": "static-7.1127",
    "ja": "static-7.1127",
    "ko": "static-7.1127",
    "lt": "static-7.1127",
    "ms": "static-7.1127",
    "nl": "static-7.1127",
    "no": "static-7.1127",
    "pl": "static-7.1127",
    "pt-br": "static-7.1127",
    "pt-pt": "static-7.1127",
    "ro": "static-7.1127",
    "ru": "static-7.1127",
    "sk": "static-7.1127",
    "sl": "static-7.1127",
    "sv": "static-7.1127",
    "th": "static-7.1127",
    "tl": "static-7.1127",
    "tr": "static-7.1127",
    "uk": "static-7.1127",
    "vi": "static-7.1127",
    "x-pseudo": "static-7.1127",
    "zh-cn": "static-7.1127",
    "zh-hk": "static-7.1127",
    "zh-tw": "static-7.1127"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ko', {version: 'static-7.1127'}); }
})();


